var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.587,
    height: 87.275,
    viewBox: "0 0 71.587 87.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-1509 266.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(1509 -192.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0.109 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M84.828,562.64h1.618l2.578,6.1h-1.8l-.441-1.081H84.447l-.432,1.081H82.25Zm1.47,3.72-.674-1.721-.683,1.721Z",
    transform: "translate(-82.25 -562.64)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M126.679,562.9h1.678v4.585h2.932v1.471h-4.611Z",
    transform: "translate(-119.318 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M157.691,578.773h2.837v1.445h-2.837Z",
    transform: "translate(-145.192 -576.1)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M179.8,562.64h1.618l2.577,6.1h-1.8l-.441-1.081h-2.336l-.432,1.081h-1.765Zm1.471,3.72-.675-1.721-.683,1.721Z",
    transform: "translate(-161.484 -562.64)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M221.647,562.9h1.773l1.445,2.344,1.445-2.344h1.773v6.055h-1.669V565.48l-1.544,2.37h-.035L223.3,565.5v3.46h-1.652Z",
    transform: "translate(-198.552 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M266.62,562.64h1.618l2.578,6.1h-1.8l-.441-1.081H266.24l-.432,1.081h-1.765Zm1.471,3.72-.675-1.721-.683,1.721Z",
    transform: "translate(-233.924 -562.64)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M308.472,562.9h1.569l2.5,3.2v-3.2h1.652v6.055h-1.474l-2.592-3.322v3.322h-1.652Z",
    transform: "translate(-270.992 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M363.917,562.9h4.844v1.47H365.6v1.021h2.863v1.4H365.6v2.163h-1.678Z",
    transform: "translate(-317.251 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M400.082,569.07a3.857,3.857,0,0,1-1.168-.164,2.262,2.262,0,0,1-.882-.506,2.231,2.231,0,0,1-.558-.865,3.531,3.531,0,0,1-.195-1.233v-3.4h1.713v3.365a1.369,1.369,0,0,0,.3.973,1.061,1.061,0,0,0,.807.316,1.085,1.085,0,0,0,.807-.3,1.293,1.293,0,0,0,.3-.943V562.9h1.713v3.356a3.549,3.549,0,0,1-.2,1.267,2.194,2.194,0,0,1-1.462,1.38A3.9,3.9,0,0,1,400.082,569.07Z",
    transform: "translate(-345.085 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M437.323,562.9h1.569l2.5,3.2v-3.2h1.652v6.055h-1.474l-2.592-3.322v3.322h-1.652Z",
    transform: "translate(-378.495 -562.859)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M478.307,562.9h2.336a4.414,4.414,0,0,1,1.449.22,3.065,3.065,0,0,1,1.073.619,2.639,2.639,0,0,1,.666.947,3.1,3.1,0,0,1,.229,1.207v.017a3.119,3.119,0,0,1-.234,1.215,2.726,2.726,0,0,1-.675.964,3.113,3.113,0,0,1-1.086.636,4.324,4.324,0,0,1-1.457.229h-2.3Zm2.364,4.567a1.791,1.791,0,0,0,1.215-.4,1.416,1.416,0,0,0,.46-1.133v-.018a1.42,1.42,0,0,0-.46-1.129,1.778,1.778,0,0,0-1.215-.4h-.686v3.08Z",
    transform: "translate(-412.689 -562.859)",
    fill: "#2a7de1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 9.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M81.595,624.075h.564v-1.338h1.663V622.2H82.158v-.88h1.86v-.537H81.595Z",
    transform: "translate(-81.595 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M99.422,620.468a1.67,1.67,0,0,0-1.679,1.7v.009a1.642,1.642,0,0,0,1.67,1.688,1.672,1.672,0,0,0,1.679-1.705A1.642,1.642,0,0,0,99.422,620.468Zm1.093,1.705a1.1,1.1,0,0,1-1.093,1.151,1.11,1.11,0,0,1-1.1-1.168,1.1,1.1,0,1,1,2.2.009Z",
    transform: "translate(-95.068 -620.468)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M123.711,621.809a.952.952,0,0,0-.269-.682,1.322,1.322,0,0,0-.949-.339h-1.429v3.287h.564v-1.193h.714l.891,1.193h.7l-.974-1.3A.975.975,0,0,0,123.711,621.809Zm-2.083.545v-1.029h.839c.43,0,.677.181.677.506s-.267.523-.681.523Z",
    transform: "translate(-114.525 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M146.821,621.325h1.031v2.75h.568v-2.75h1.031v-.537h-2.63Z",
    transform: "translate(-136.014 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M167.417,622.152h-1.555v-1.364H165.3v3.287h.564v-1.382h1.555v1.382h.563v-3.287h-.563Z",
    transform: "translate(-151.43 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M185.981,622.685h1.676v-.533h-1.676v-.832h1.873v-.532h-2.436v3.287h2.458v-.533h-1.9Z",
    transform: "translate(-168.217 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M211.1,624.075h.564v-1.338h1.663V622.2h-1.663v-.88h1.859v-.537H211.1Z",
    transform: "translate(-189.64 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M230.382,622.682c0,.583-.29.9-.817.9s-.83-.329-.83-.927v-1.871h-.563v1.894a1.388,1.388,0,1,0,2.774-.026v-1.868h-.563Z",
    transform: "translate(-203.887 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M247.229,621.325h1.031v2.75h.568v-2.75h1.031v-.537h-2.63Z",
    transform: "translate(-219.787 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M267.626,622.682c0,.583-.29.9-.817.9s-.83-.338-.83-.927v-1.871h-.564v1.894a1.389,1.389,0,1,0,2.774-.026v-1.868h-.563Z",
    transform: "translate(-234.96 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M288.446,621.809a.953.953,0,0,0-.269-.682,1.324,1.324,0,0,0-.949-.339H285.8v3.287h.563v-1.193h.715l.891,1.193h.7l-.974-1.3A.975.975,0,0,0,288.446,621.809Zm-2.084.545v-1.029h.839c.43,0,.677.181.677.506s-.267.523-.681.523Z",
    transform: "translate(-251.967 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M305.5,622.685h1.675v-.533H305.5v-.832h1.873v-.532h-2.437v3.287H307.4v-.533H305.5Z",
    transform: "translate(-267.934 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M331.476,620.468a1.67,1.67,0,0,0-1.679,1.7v.009a1.642,1.642,0,0,0,1.67,1.688,1.672,1.672,0,0,0,1.679-1.705A1.642,1.642,0,0,0,331.476,620.468Zm1.093,1.705a1.1,1.1,0,0,1-1.093,1.151,1.11,1.11,0,0,1-1.1-1.168,1.1,1.1,0,1,1,2.2.009Z",
    transform: "translate(-288.675 -620.468)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M353.118,624.075h.563v-1.338h1.663V622.2h-1.663v-.88h1.86v-.537h-2.423Z",
    transform: "translate(-308.132 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M379.283,620.468a1.67,1.67,0,0,0-1.679,1.7v.009a1.642,1.642,0,0,0,1.67,1.688,1.672,1.672,0,0,0,1.679-1.705A1.642,1.642,0,0,0,379.283,620.468Zm1.093,1.705a1.1,1.1,0,0,1-1.093,1.151,1.11,1.11,0,0,1-1.1-1.168,1.1,1.1,0,1,1,2.2.009Z",
    transform: "translate(-328.562 -620.468)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M403.574,621.809a.952.952,0,0,0-.269-.682,1.324,1.324,0,0,0-.949-.339h-1.429v3.287h.563v-1.193h.715l.89,1.193h.7l-.975-1.3A.975.975,0,0,0,403.574,621.809Zm-2.084.545v-1.029h.839c.43,0,.677.181.677.506s-.268.523-.681.523Z",
    transform: "translate(-348.02 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M421.321,620.788h-1.258v3.287h.564v-1.084h.637a1.162,1.162,0,0,0,1.315-1.122C422.579,621.213,422.085,620.788,421.321,620.788Zm-.044,1.671h-.65v-1.134h.668c.268,0,.716.072.716.567C422.011,622.236,421.723,622.459,421.277,622.459Z",
    transform: "translate(-363.986 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M439.867,622.152h-1.555v-1.364h-.563v3.287h.563v-1.382h1.555v1.382h.564v-3.287h-.564Z",
    transform: "translate(-378.741 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M457.415,620.655l-1.5,3.31h.594l.364-.811h1.53l.36.811h.611l-1.5-3.31Zm-.306,1.965.534-1.188.531,1.188Z",
    transform: "translate(-393.901 -620.624)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M481.038,623.044l-1.773-2.256h-.486v3.287h.555v-2.313l1.822,2.313h.437v-3.287h-.554Z",
    transform: "translate(-412.974 -620.735)",
    fill: "#16437b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M499.7,621.937c-.693-.148-.748-.3-.748-.5,0-.228.224-.387.545-.387a1.241,1.241,0,0,1,.817.309l.087.072.333-.442-.082-.066a1.72,1.72,0,0,0-1.147-.4,1.009,1.009,0,0,0-1.117.955c0,.658.536.866,1.117.992.66.14.713.293.713.487,0,.247-.232.414-.576.414a1.351,1.351,0,0,1-.98-.407l-.083-.075-.355.421.078.07a1.894,1.894,0,0,0,1.327.519,1.032,1.032,0,0,0,1.157-.986C500.782,622.258,500.2,622.047,499.7,621.937Z",
    transform: "translate(-429.194 -620.513)",
    fill: "#16437b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(1509 -266.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M163.476,300.166s-10.69.095-13.66-2.546a24.5,24.5,0,0,1,2.7-26.621L132,277.081l8.162,23.785.008.009.007.007.02.02.016.016.03.029.025.023.041.037.037.031.052.043.048.038.064.049.061.045.076.055.073.05.09.06.086.056.1.064.1.06.119.068.114.064.135.072.128.066.154.076.142.069.174.079.154.069.206.086.157.065c.087.035.181.07.274.105l.218.081c.109.039.219.079.335.118l.2.065c.09.029.179.059.274.088l.233.069c.093.027.184.055.281.082l.256.069.3.079.279.068c.1.026.21.051.319.076l.3.067.339.072.325.064.362.068.348.061.387.063.369.057.414.059.39.052.442.053.413.047c.154.016.313.032.471.047.143.014.286.028.433.041.165.014.336.027.506.04.15.012.3.024.451.034.18.012.367.023.553.034.152.009.3.019.457.026.2.01.413.018.622.026.148.006.293.013.444.018.271.009.551.015.832.021l.289.007h0q1.181.019,2.485,0c13.991-.233,19.121,4.664,13.525,10.027s-16.09,7.25-16.09,7.25h32.413S218.041,301.565,163.476,300.166Z",
    transform: "translate(-131.996 -255.931)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M239.527,424.288q-1.305.022-2.485,0a24.435,24.435,0,0,0,16.915,6.776c.407,0,.812-.011,1.214-.031C256.09,427.119,250.573,424.1,239.527,424.288Z",
    transform: "translate(-214.343 -376.076)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M350.67,208.156a24.52,24.52,0,0,1,12.974,36.59l11.36-.2V200.943Z",
    transform: "translate(-303.417 -200.943)",
    fill: "#2a7de1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M204.543,264.44c2.961,2.646,13.666,2.551,13.666,2.551,12.624.324,20.665,1.635,25.571,3.459a24.527,24.527,0,1,0-39.237-6.01Z",
    transform: "translate(-186.729 -222.686)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M204.543,264.44c2.961,2.646,13.666,2.551,13.666,2.551,12.624.324,20.665,1.635,25.571,3.459a24.527,24.527,0,1,0-39.237-6.01Z",
    transform: "translate(-186.729 -222.686)",
    fill: "#ffc629"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1668749d81a5f8627e57c1fa1f729863.svg";
export { ForwardRef as ReactComponent };